export default "__VITE_ASSET__Cq1apiwb__"